
import { PensionTaxInfoDetailsClient } from "../../../../../../../../Wrap/Api/Account/PensionTaxInfoDetails";

export class ProductOverviewSippTaxInformationAction {
    public static get(hierarchyId: string, callback) {
        const client = new PensionTaxInfoDetailsClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => {callback(data)});

        promise.onError(() => {});
    }
}